import React, { useContext } from "react"
import Img from "gatsby-image"
import { UIContext } from "./layout"

export default function BreakpointImage({ fluidSizes, className, ...rest }) {
  const {
    state: { breakpoint },
  } = useContext(UIContext)

  return (
    <Img
      className={className}
      fluid={fluidSizes[breakpoint].childImageSharp.fluid}
      {...rest}
    />
  )
}
